import { useState } from "react";
import "./Navbar.css";
import {
  FaBell,
  FaSearch,
  FaChevronDown,
} from "react-icons/fa";

function Navbar({ student }) {

  const [notificationsOpen, setNotificationsOpen] = useState(false);

  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: "meeting",
      title: "Placement Training Meeting",
      message: "All BCA 4th Semester students must attend.",
      date: "30 July 2026",
      time: "3:00 PM",
      meetingLink: "https://meet.google.com/",
      hostedBy: "Training & Placement Cell",
      unread: true,
    },
    {
      id: 2,
      type: "announcement",
      title: "Semester Notice",
      message: "Internal examination schedule has been published.",
      date: "28 July 2026",
      time: "11:30 AM",
      unread: false,
    },
  ]);

  const unreadCount = notifications.filter(
    (item) => item.unread
  ).length;

  const markAllRead = () => {
    setNotifications((prev) =>
      prev.map((item) => ({
        ...item,
        unread: false,
      }))
    );
  };

  return (
    <div
      className="student-page-navbar"
      data-aos="fade-down"
      data-aos-duration="700"
    >
      {/* LEFT */}

      <div className="student-page-navbar-left">
        <h2>
          Welcome Back,
          <span> {student?.fullname || "Student"} 👋</span>
        </h2>

        <p>Have a productive learning day.</p>
      </div>

      {/* RIGHT */}

      <div className="student-page-navbar-right">

        {/* Search */}

        <div className="student-page-navbar-search-box">
          <FaSearch className="student-page-navbar-search-icon" />

          <input
            type="text"
            placeholder="Search..."
          />
        </div>

        {/* Notification Bell */}

        <button
          type="button"
          className="student-page-navbar-notification"
          onClick={() =>
            setNotificationsOpen(!notificationsOpen)
          }
        >
          <FaBell />

          {unreadCount > 0 && (
            <span className="student-page-navbar-badge">
              {unreadCount}
            </span>
          )}
        </button>

        {/* Notification Panel */}

        {notificationsOpen && (
          <div className="student-page-navbar-notification-panel">

            <div className="student-page-navbar-notification-heading">

              <h3>Notifications</h3>

              {unreadCount > 0 && (
                <button onClick={markAllRead}>
                  Mark all read
                </button>
              )}

            </div>

            {notifications.length > 0 ? (

              notifications.map((item) => (

                <div
                  key={item.id}
                  className={`notification-card ${
                    item.unread ? "unread" : ""
                  }`}
                >

                  <div className="notification-top">

                    <span className="notification-type">

                      {item.type === "meeting"
                        ? "📹 Meeting"
                        : "📢 Announcement"}

                    </span>

                    {item.unread && (
                      <span className="notification-dot"></span>
                    )}

                  </div>

                  <h4>{item.title}</h4>

                  <p>{item.message}</p>

                  <div className="notification-info">

                    <span>📅 {item.date}</span>

                    <span>🕒 {item.time}</span>

                  </div>

                  {item.hostedBy && (
                    <small>
                      Hosted By : {item.hostedBy}
                    </small>
                  )}

                  {item.meetingLink && (
                    <button
                      className="join-btn"
                      onClick={() =>
                        window.open(
                          item.meetingLink,
                          "_blank"
                        )
                      }
                    >
                      Join Meeting
                    </button>
                  )}

                </div>

              ))

            ) : (

              <p className="student-page-navbar-empty-notifications">
                No notifications available.
              </p>

            )}

          </div>
        )}

        {/* Profile */}

        <div className="student-page-navbar-profile">

          <img
            src="https://i.pravatar.cc/150?img=12"
            alt="Student"
            className="student-page-navbar-profile-image"
          />

          <div className="student-page-navbar-profile-info">

            <h4>
              {student?.fullname || "Student"}
            </h4>

            <p>
              {student?.stream || "Student"}
            </p>

          </div>

          <FaChevronDown />

        </div>

      </div>

    </div>
  );
}

export default Navbar;